import { render, staticRenderFns } from "./SkillsBorder.vue?vue&type=template&id=4328dc1e&scoped=true&v-for=(itsKillsTitle%2C%20index)%20in%20itsKillsTitle&%3Akey=index&"
import script from "./SkillsBorder.js?vue&type=script&lang=js&"
export * from "./SkillsBorder.js?vue&type=script&lang=js&"
import style0 from "./SkillsBorder.scss?vue&type=style&index=0&id=4328dc1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4328dc1e",
  null
  
)

export default component.exports